const Logo = ({ className }) => (
  <svg
    version="1.1"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 545.78 159.57"
    fill="#1c1d1f"
    xmlSpace="preserve"
  >
    <path d="M110.16,22.78h-20.69l-51.66,45.61V22.78h-14.81v114.01h14.81v-49.27l54.67,49.27h20.83l-64.92-59.56,61.76-54.45h.01Z" />
    <path d="M128.43,136.79h64.29v-14.13h-49.47v-41.47h49.47v-14.13h-49.47v-30.15h49.47v-14.13h-64.29v114.01Z" />
    <path d="M289.01,88.36c0,11.41-.67,17.91-4.5,24.09-6.99,11.32-20.78,12.2-24.85,12.2s-17.86-.88-24.85-12.22c-3.83-6.14-4.5-12.65-4.5-24.06V22.79h-14.81v65.58c0,12.74.52,22.56,7.41,32.71,9.98,14.63,25.49,17.7,36.73,17.7s26.76-3.09,36.74-17.72c6.88-10.14,7.41-19.96,7.41-32.7V22.78h-14.81v65.58h.04-.01Z" />
    <path d="M420.57,109.31l-87.42-86.53h-6.53v114.01h14.81V51.85l85.71,84.94h8.24V22.78h-14.81v86.53Z" />
    <path d="M523,36.91v-14.13h-64.3v114.01h64.3v-14.13h-49.49v-41.47h49.49v-14.13h-49.49v-30.15h49.49Z" />
  </svg>
);

export default Logo;
